import './App.css';
import { useState, useEffect } from "react";
import { projectURL } from './utils/mockdata';

const topics = [
    'Account Access',
    'Forgot password',
    'Blocked My IP',
    'Safety & Reporting',
    'Other',
];

const HelpCenter = () => {
    const [selectedTopic, setSelectedTopic] = useState(topics[0]);
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen)
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setSuccessMessage('');
        setErrorMessage('');
        setLoading(true);

        const payload = {
            email: email,
            subject: selectedTopic,
            description: description,
        };

        try {
            const URL = projectURL + 'profiles/help-center';
            const res = await fetch(URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!res.ok) {
                const text = await res.text();
                throw new Error(text || `${res.status} ${res.statusText}`);
            }

            setSuccessMessage('Help request submitted successfully.');
            setDescription('');
        } catch (err) {
            console.error('Help center submit error:', err);
            setErrorMessage('Failed to submit request. Please try again.');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!successMessage) return;
        const t = setTimeout(() => setSuccessMessage(''), 2000);
        return () => clearTimeout(t);
    }, [successMessage]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50">

            {/* Header */}
            < header className="container mx-auto px-4 py-6" >
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                        <div className="flex items-center justify-center">
                            <img className="ring-2 ring-blue max-w-10 border rounded-full p-1.5 object-cover w-8 h-8 md:w-10 md:h-10" src="icon.jpg" alt="Socio" />
                        </div>
                        <span className="text-xl sm:text-2xl md:text-3xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
                            Socio
                        </span>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex items-center space-x-8">
                        <a href="/#features" className="text-gray-600 hover:text-purple-600 transition-colors">
                            Features
                        </a>
                        <a href="/#community" className="text-gray-600 hover:text-purple-600 transition-colors">
                            Community
                        </a>
                        <a href="/#about" className="text-gray-600 hover:text-purple-600 transition-colors">
                            About
                        </a>
                        <a href="/login" className="px-4 py-2 border border-purple-200 text-purple-600 hover:bg-purple-50 bg-transparent rounded-md transition-colors">
                            Log In
                        </a>
                    </nav>

                    {/* Mobile Menu Button */}
                    <button
                        onClick={toggleMobileMenu}
                        className="md:hidden p-2 rounded-md text-gray-600 hover:text-purple-600 hover:bg-gray-100 transition-colors"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {isMobileMenuOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            )}
                        </svg>
                    </button>
                </div>

                {/* Mobile Navigation Menu */}
                {
                    isMobileMenuOpen && (
                        <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
                            <nav className="flex flex-col space-y-4 pt-4">
                                <a
                                    href="/#features"
                                    className="text-gray-600 hover:text-purple-600 transition-colors py-2"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    Features
                                </a>
                                <a
                                    href="/#community"
                                    className="text-gray-600 hover:text-purple-600 transition-colors py-2"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    Community
                                </a>
                                <a
                                    href="/#about"
                                    className="text-gray-600 hover:text-purple-600 transition-colors py-2"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    About
                                </a>
                                <a target="__blank" href="/login" className="w-full mt-4 px-4 py-2 border border-purple-200 text-purple-600 hover:bg-purple-50 bg-transparent rounded-md transition-colors text-left">
                                    Log In
                                </a>
                            </nav>
                        </div>
                    )
                }
            </header >


            {/*main content*/}
            <div className="bg-gray-50 py-6 px-4 md:py-10 md:px-6">
                <div className="max-w-5xl mx-auto">
                    <header className="mb-6">
                        <h1 className="text-2xl md:text-3xl font-semibold text-gray-800">Help Center</h1>
                        <p className="text-sm text-gray-600 mt-1">Tell us what's going on and we'll help you out.</p>
                    </header>

                    <div className="bg-white shadow rounded-lg overflow-hidden">
                        <div className="grid grid-cols-1 md:grid-cols-3">
                            <aside className="md:col-span-1 border-b md:border-r p-4 md:p-6">
                                <h2 className="text-lg font-medium text-gray-700">Choose a topic</h2>
                                <p className="text-sm text-gray-500 mb-4">Select the issue that best matches your request.</p>
                                <ul className="space-y-2">
                                    {topics.map((t) => (
                                        <li key={t}>
                                            <button
                                                onClick={() => setSelectedTopic(t)}
                                                className={`w-full text-left px-3 py-2 rounded-md transition-colors text-sm md:text-base ${selectedTopic === t ? 'bg-indigo-600 text-white' : 'hover:bg-gray-100 text-gray-700'
                                                    }`}
                                            >
                                                {t}
                                            </button>
                                        </li>
                                    ))}
                                </ul>

                                <div className="mt-6 text-sm text-gray-600">
                                    <p className="font-medium">Need something else?</p>
                                    <p>If your topic isn't listed, choose "Other" and describe the issue.</p>
                                </div>
                            </aside>

                            <main className="md:col-span-2 p-4 md:p-6">
                                <form onSubmit={handleSubmit} className="space-y-4">
                                    {errorMessage && (
                                        <div className="text-sm text-red-600">{errorMessage}</div>
                                    )}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Topic</label>
                                        <div className="mt-1">
                                            <input readOnly value={selectedTopic} className="w-full rounded-md border-gray-300 shadow-sm" />
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Email</label>
                                            <input
                                                type="email"
                                                required
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                placeholder="you@example.com"
                                                className="mt-1 w-full rounded-md border-gray-300 shadow-sm p-2"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Username (optional)</label>
                                            <input
                                                value={username}
                                                onChange={(e) => setUsername(e.target.value)}
                                                placeholder="username"
                                                className="mt-1 w-full rounded-md border-gray-300 shadow-sm p-2"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Description</label>
                                        <textarea
                                            required
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            rows={6}
                                            placeholder="Describe the issue in detail"
                                            className="mt-1 w-full rounded-md border-gray-300 shadow-sm p-2"
                                        />
                                    </div>

                                    <div className="flex flex-col md:flex-row items-center md:justify-between mt-6 gap-3">
                                        <div className="text-sm text-gray-500">We'll respond to the email you provide.</div>
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className={`inline-flex justify-center items-center px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 w-full md:w-auto ${loading ? 'opacity-60 cursor-not-allowed' : ''}`}
                                        >
                                            {loading ? 'Submitting...' : 'Submit Request'}
                                        </button>
                                    </div>
                                </form>

                            </main>
                        </div>
                    </div>
                </div>
            </div >

            {/* Success Modal */}
            {successMessage && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="absolute inset-0 bg-black opacity-40" onClick={() => setSuccessMessage('')}></div>
                    <div className="relative bg-white rounded-lg p-6 shadow-lg max-w-sm mx-4 text-center">
                        <h3 className="text-lg font-medium text-gray-800">{successMessage}</h3>
                    </div>
                </div>
            )}

            {/* Footer */}
            <footer className="bg-gray-900 text-white py-12">
                <div className="container mx-auto px-4">
                    <div className="grid md:grid-cols-4 gap-8">
                        <div className="space-y-4">
                            <div className="flex items-center space-x-2">
                                <div className="w-8 h-8 flex items-center justify-center">
                                    <img className="ring-2 ring-blue max-w-10 border rounded-full p-1.5" src="socio_icon-removebg-preview.png" alt="Socio" />
                                </div>
                                <span className="text-xl font-bold">Socio</span>
                            </div>
                            <p className="text-gray-400">Connecting people and communities around the world.</p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-4">Product</h4>
                            <ul className="space-y-2 text-gray-400">
                                <li>
                                    <a href="/#features" className="hover:text-white transition-colors">
                                        Features
                                    </a>
                                </li>
                                {/* <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Pricing
                  </a>
                </li> */}
                                <li>
                                    <a href="Socio.apk" className="hover:text-white transition-colors">
                                        Mobile App
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-4">Company</h4>
                            <ul className="space-y-2 text-gray-400">
                                <li>
                                    <a href="/#about" className="hover:text-white transition-colors">
                                        About
                                    </a>
                                </li>
                                {/* <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Press
                  </a>
                </li> */}
                            </ul>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-4">Support</h4>
                            <ul className="space-y-2 text-gray-400">
                                <li>
                                    <a href="#about" className="hover:text-white transition-colors">
                                        Help Center
                                    </a>
                                </li>
                                <li>
                                    <a href="/PrivacyPolicy" className="hover:text-white transition-colors">
                                        Privacy
                                    </a>
                                </li>
                                <li>
                                    <a href="/TermsOfService" className="hover:text-white transition-colors">
                                        Terms
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
                        <p>&copy; 2026 Socio. All rights reserved.</p>
                    </div>
                </div>
            </footer>

        </div >
    );
};

export default HelpCenter;